module.exports = __webpack_public_path__ + "media/flags/gd-71f68a5b.svg";